import { Grid } from "@mui/material";
import { useWatch } from "react-hook-form";
import { IFormValues } from "../../../types";
import { AdditionalDriversDetails, BillingOwnerDetails, BookingOwnerDetails, MainDriverDetails } from "./sections";

const TabDriverDetails = () => {
    
    const additionalDriversDetails = useWatch<IFormValues, 'additionalDriversDetails'>({
        name: 'additionalDriversDetails'
    });

    return (
        <Grid container spacing={2} alignItems="start">
            <Grid item container xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <MainDriverDetails />
                </Grid>
                <Grid item xs={12}>
                    <BookingOwnerDetails />
                </Grid>
            </Grid>
            <Grid item container xs={12} sm={12} md={6} spacing={2}>
                <Grid item xs={12}>
                    <BillingOwnerDetails />
                </Grid>
                {additionalDriversDetails.length > 0 &&
                    <Grid item xs={12}>
                        <AdditionalDriversDetails />
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default TabDriverDetails;